import SC from 'styled-components'
import {
  AnnualReviewQuestionColumn as Column,
  AnnualReviewQuestion as Q,
  AnnualReviewQuestionsSet as Set
} from '~bank-annual-review/components/AnnualReviewQuestion'
import {
  questionnaire1Labels,
  questionnaire3Labels,
  questionnaireDemoLabels
} from '~bank-annual-review/constants/questionnaireLabels'
import { AnnualReviewDetails } from '~bank-annual-review/types/AnnualReviewDetails'

const Questions = SC.div`
  margin-top: 34px;
`

type Props = {
  data: AnnualReviewDetails
}

export const LicensingQuestionnaire = (props: Props) => {
  const { data } = props

  let questionnaire, questionnaireLabels
  if (data?.showQuestionnaire1) {
    questionnaire = data?.showQuestionnaire1
    questionnaireLabels = questionnaire1Labels
  } else if (data?.showQuestionnaire3) {
    questionnaire = data?.showQuestionnaire3
    questionnaireLabels = questionnaire3Labels
  } else if (data?.showQuestionnaireDemo) {
    questionnaire = data?.showQuestionnaireDemo
    questionnaireLabels = questionnaireDemoLabels
  }

  if (!questionnaire) return null

  return (
    <Questions>
      <Set>
        <Column>
          <Q label={questionnaireLabels.licensingLocChanges}>{questionnaire?.licensingLocChanges || '---'}</Q>
        </Column>
        <Column>
          {questionnaire?.licensingLocChangesMmcc && (
            <Q label={questionnaireLabels.licensingLocChangesMmcc}>{questionnaire?.licensingLocChangesMmcc || '---'}</Q>
          )}
        </Column>
      </Set>
      <Set>
        <Column>
          <Q label={questionnaireLabels.licensingNameChanges}>{questionnaire?.licensingNameChanges || '---'}</Q>
        </Column>
        <Column>
          {questionnaire?.licensingNameChangesMmcc && (
            <Q label={questionnaireLabels.licensingNameChangesMmcc}>
              {questionnaire?.licensingNameChangesMmcc || '---'}
            </Q>
          )}
        </Column>
      </Set>
      <Set>
        <Column>
          {questionnaire?.licensingNamePrior && <Q label="Prior Name:">{questionnaire?.licensingNamePrior || '---'}</Q>}
        </Column>
      </Set>
    </Questions>
  )
}
